<?php

\Core\View::$template = function () {

    $html = ''; 
    $html_favorite = '';   
    $pv = \Core\View::$page_vars;
    \ISOPHP\js_core::$console->log('pagevars: ', $pv);
    $rqd = $pv['request_data'];
    
    foreach ($rqd['jobs'] as $one_job) {

//        if($rqd_user_logged !== ''){
//            $html_favorite = '';
//        }

        $html = $html .
            '    <div class="col-sm-12">
                    <div class="col-sm-1">
                        &nbsp;
                    </div>
                    <div class="col-sm-12 one_account">
                        <p class="job_list_id">Job ID : <span class="job_id">' . $one_job['id'] . '</span></p>
                        <p class="job_list_name"><span class="job_title">' . $one_job['title'] . '</span></p>
                        <p class="job_list_description">' . $one_job['description'] . '</p>
                            
                    </div>
                        ';
                            
        $html = $html . $html_favorite . '</div>
                    </div>
                    <div class="col-sm-1">
                        &nbsp;
                    </div>
                 </div>';
    }

    return $html;

};


// WEBPACK FOOTER //
// app/JobList/View/AllJobs.php